export default "__VITE_ASSET__RH8e08Up__"